import React from 'react';
import useStyles from './Styles';
import IconButton from '@mui/material/IconButton';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import TableHead from '@mui/material/TableHead';
//import Divider from '@mui/material/Divider';
import Hidden from '@mui/material/Hidden';
import StoreImg from './StoreImg';
import {Item,Owner} from './Inc';
import {Tools} from './Tools';

interface ItemCheckTableProps {
    owner:Owner,
    items:Item[],
    uncheck(e: React.MouseEvent<HTMLElement>): void,
    check(e: React.MouseEvent<HTMLElement>): void,
    isChecked(id:number):boolean,
	checkable?(item:Item):boolean,
}

const ItemCheckTable = (pr:ItemCheckTableProps)=> {
    const classes = useStyles();	

	const checkable = (item:Item)=>{
		if(pr.checkable){
			return pr.checkable(item);
		}
		return true;
	}

	const ItemRow = (props:{item:Item,owner_id:number,index:number})=>{
		let num_stock = 0;
		if( props.item.num_stock ){
			num_stock = props.item.num_stock;
		}
		return (
			<TableRow>
				{checkable(props.item) ? (
				<TableCell className={classes.tableCellNowrap} align="center" style={{width:'3em'}}>
					{pr.isChecked(props.item.item_id) ? (
						<IconButton aria-label="edit" className={classes.primary} onClick={pr.uncheck} data-index={props.index}><CheckBoxIcon/></IconButton>
					):(
						<IconButton aria-label="edit" className={classes.primary} onClick={pr.check} data-index={props.index}><CheckBoxOutlineBlankIcon/></IconButton>
					)}
				</TableCell>
				):(
				<TableCell className={classes.tableCellNowrap} align="center" style={{width:'3em'}}>　</TableCell>
				)}
				<Hidden smDown implementation="js">
					<TableCell className={classes.tableCellDense} align="center" style={{width:'5em'}}>
						<StoreImg owner_id={pr.owner.owner_id} img_id={props.item.img_id} className="imgList"/>
					</TableCell>
				</Hidden>
				<TableCell className={classes.tableCellDense}>
					<span className={classes.itemId}>ID:{props.item.item_id}</span>　
					<Hidden smUp implementation="js">
						<br/>
					</Hidden>
					{props.item.item_name}<br/>
					{props.item.page_name!==null && props.item.page_name !== "" ? (
					<div className="with_page_name">{props.item.page_name}</div>
					):(
					<div className="with_page_name">　</div>
					)}
				</TableCell>
				<TableCell className={classes.tableCellNowrap} align="right">{num_stock}</TableCell>
				<Hidden smDown implementation="js">
					<TableCell className={classes.tableCellNowrap} align="center" style={{width:'6em'}}>
						{Tools.colorLabel("item_status",props.item.status,props.item.status_label)}<br/>
						{props.item.sample_flag==='1' &&
							<span className="cl cl-sample">見本あり</span>
						}
					</TableCell>
				</Hidden>                                
			</TableRow>
		);
	};

	//const itemRows = ()=>{
	//	return pr.items.map( (item:Item,index:number)=>{
	//		const key = "item"+index;
	//		return <ItemRow item={item} owner_id={pr.owner.owner_id} index={index} key={key}/>
	//	});
	//};

	//console.log(pr.items);

	return (
        <Table id="item_check_table">
            <TableHead>
                <TableRow>
                    <TableCell className={classes.tableHeadNowrap} align="center">選択</TableCell>
                    <Hidden smDown implementation="js">
                        <TableCell className={classes.tableHeadNowrap} align="center">画像</TableCell>
                    </Hidden>
                    <TableCell className={classes.tableHeadNowrap} align="center">商品</TableCell>
                    <TableCell className={classes.tableHeadNowrap} align="center">在庫</TableCell>
                    <Hidden smDown implementation="js">
                    <TableCell className={classes.tableHeadNowrap} align="center">状態表示</TableCell>
                    </Hidden>
                </TableRow>
            </TableHead>
            <TableBody>
				{pr.items.map( (item:Item,index:number)=>{
					const key = "item"+index;
					return <ItemRow item={item} owner_id={pr.owner.owner_id} index={index} key={key}/>
				})}
            </TableBody>
        </Table>
	);
}

export default ItemCheckTable;
